import { getAuth } from 'firebase/auth';

export class Token {
  static async get(forceRefresh = false): Promise<string> {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      throw new Error('No authenticated user');
    }

    const idToken = await user.getIdToken(forceRefresh);
    return idToken;
  }
}
